import { render, staticRenderFns } from "./VenueSuccessPage.vue?vue&type=template&id=3636ca20&scoped=true"
import script from "./VenueSuccessPage.vue?vue&type=script&lang=ts"
export * from "./VenueSuccessPage.vue?vue&type=script&lang=ts"
import style0 from "./VenueSuccessPage.vue?vue&type=style&index=0&id=3636ca20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3636ca20",
  null
  
)

export default component.exports